import { render, staticRenderFns } from "./ServicesTabs.vue?vue&type=template&id=0b808d90"
import script from "./ServicesTabs.vue?vue&type=script&lang=js"
export * from "./ServicesTabs.vue?vue&type=script&lang=js"
import style0 from "./ServicesTabs.vue?vue&type=style&index=0&id=0b808d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports